import React from "react";

import { LegendProps } from "./Legend.types";
import { useStyles } from "./Legend.styles";
import { Box } from "..";

function Legend(props: LegendProps) {
  const { children, ...other } = props;

  const classes = useStyles(props);

  return (
    <Box className={classes.root} {...other} component="ul">
      {children}
    </Box>
  );
}

export default Legend;
